// import React, { useEffect, useRef } from "react";
// import { Label } from "reactstrap";

// const FormEditor = ({ name, label, value = "", onChange }) => {
//   const editorRef = useRef(null);
//   const editorInstanceRef = useRef(null);

//   /* ================= CKEDITOR INIT ================= */
//   useEffect(() => {
//     if (!window.CKEDITOR || !editorRef.current) return;
//     if (editorInstanceRef.current) return;
//     const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3008/";
//     const uploadUrl = new URL("api/Ckupload", BASE_URL.endsWith("/") ? BASE_URL : `${BASE_URL}/`).toString();

//     const editor = window.CKEDITOR.replace(editorRef.current, {
//       height: 300,
//       toolbarCanCollapse: false,

//       /*  Disable security warning */
//       versionCheck: false,
//       /* Allow ALL HTML */
//       allowedContent: true,
//       extraAllowedContent: "*(*);*{*}",

//       /*  SHOW ALL ICONS (from your code, fixed) */
//      toolbar: [
//         {
//           name: "full",
//           items: [
//             // Document
//             "Source",
//             //"Save",
//             // "NewPage",

//             // "Print",

//             // Clipboard
//             // "Cut",
//             // "Copy",
//             // "Paste",
//             // "PasteText",
//             // "PasteFromWord",
//             // "Undo",
//             // "Redo",

//             // Editing
//             "Find",
//             "Replace",
//             "SelectAll",
//             "Scayt",

//             // // Forms
//             // "Form",
//             // "Checkbox",
//             // "Radio",
//             // "TextField",
//             // "Textarea",
//             // "Select",
//             // "Button",
//             // "ImageButton",
//             // "HiddenField",

//             // Basic styles
//             "Bold",
//             "Italic",
//             "Underline",
//             "Strike",
//             "Subscript",
//             "Superscript",
//             "RemoveFormat",

//             // Paragraph
//             "NumberedList",
//             "BulletedList",
//             "Outdent",
//             "Indent",
//             "Blockquote",
//             "CreateDiv",
//             "JustifyLeft",
//             "JustifyCenter",
//             "JustifyRight",
//             "JustifyBlock",

//             // Links
//             "Link",
//             "Unlink",
//             "Anchor",

//             // Insert
//             "Image",
//             "Flash",
//             "Table",
//             "HorizontalRule",
//             "Smiley",
//             "SpecialChar",
//             "PageBreak",
//             "Iframe",

//             // Colors
//             "TextColor",
//             "BGColor",

//             // Tools
//             "Maximize",
//             "ShowBlocks",

//             // Styles
//             "Styles",
//             "Format",
//             "Font",
//             "FontSize",
//           ]
//         }
//       ],

//       /*  REQUIRED plugins (NO flash) */
//       extraPlugins:
//         "colorbutton,font,justify,iframe,forms,div,smiley,pagebreak,templates,bidi",
//       /* Remove warnings */
//       removePlugins: "notification,notificationaggregator",

//       /*  Image upload */
//           filebrowserUploadUrl: `${process.env.REACT_APP_API_URL}api/Ckupload`,
//                filebrowserUploadMethod: "post",
//     });

//     /* change handler */
//     editor.on("change", () => {
//       onChange?.({
//         target: {
//           name,
//           value: editor.getData(),
//         },
//       });
//     });

//     /* initial value */
//     editor.setData(value || "");

//     editorInstanceRef.current = editor;

//     return () => {
//       editorInstanceRef.current?.destroy();
//       editorInstanceRef.current = null;
//     };
//   }, []);

//   /* ================= SYNC VALUE (EDIT MODE) ================= */
//   useEffect(() => {
//     if (!editorInstanceRef.current) return;
//     const current = editorInstanceRef.current.getData();
//     if (current !== value) {
//       editorInstanceRef.current.setData(value || "");
//     }
//   }, [value]);

//   return (
//     <div className="mb-3">
//       {label && (
//         <Label className="form-label" htmlFor={name}>
//           {label}
//         </Label>
//       )}

//       {/* CKEditor mounts here */}
//       <textarea ref={editorRef} name={name} />
//     </div>
//   );
// };

// export default FormEditor;

import React, { useEffect, useRef } from "react";
import { Label } from "reactstrap";

const FormEditor = ({ name, label, value = "", onChange }) => {
  const editorRef = useRef(null);
  const editorInstanceRef = useRef(null);
  const latestValueRef = useRef(value || "");

  useEffect(() => {
    latestValueRef.current = value || "";
  }, [value]);

  /* ================= CKEDITOR INIT ================= */
  useEffect(() => {
    if (!window.CKEDITOR || !editorRef.current) return;
    if (editorInstanceRef.current) return;
    const BASE_URL = process.env.REACT_APP_API_URL || "https://devapi.rvrex.com/";

    const editor = window.CKEDITOR.replace(editorRef.current, {
      height: 300,
      toolbarCanCollapse: false,
protectedSource: [],

  contentsCss: [
    'body { margin:10px; }',
    'iframe { width:100% !important; height:350px !important; }'
  ],
      /*  Disable security warning */
      versionCheck: false,
      /* Allow ALL HTML */
      allowedContent: true,
      // extraAllowedContent: "*(*);*{*}",
      extraAllowedContent: 'iframe[*]{*}(*); a[*]; img[*]; div[*]; span[*]; p[*]',

      /*  SHOW ALL ICONS (from your code, fixed) */
     toolbar: [
        {
          name: "full",
          items: [
            // Document
            "Source",
            //"Save",
            // "NewPage",

            // "Print",

            // Clipboard
            // "Cut",
            // "Copy",
            // "Paste",
            // "PasteText",
            // "PasteFromWord",
            // "Undo",
            // "Redo",

            // Editing
            "Find",
            "Replace",
            "SelectAll",
            "Scayt",

            // // Forms
            // "Form",
            // "Checkbox",
            // "Radio",
            // "TextField",
            // "Textarea",
            // "Select",
            // "Button",
            // "ImageButton",
            // "HiddenField",

            // Basic styles
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "RemoveFormat",

            // Paragraph
            "NumberedList",
            "BulletedList",
            "Outdent",
            "Indent",
            "Blockquote",
            "CreateDiv",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",

            // Links
            "Link",
            "Unlink",
            "Anchor",

            // Insert
            "Image",
            "Flash",
            "Table",
            "HorizontalRule",
            "Smiley",
            "SpecialChar",
            // OLD:
            // "PageBreak",
            // "Iframe",
            "PageBreak",
            "Iframe",
            "Embed",

            // Colors
            "TextColor",
            "BGColor",

            // Tools
            "Maximize",
            "ShowBlocks",

            // Styles
            "Styles",
            "Format",
            "Font",
            "FontSize",
          ]
        }
      ],

      /*  REQUIRED plugins (NO flash) */
  // OLD:
  // extraPlugins:
  // "colorbutton,font,justify,iframe,forms,div,smiley,pagebreak,templates,bidi,clipboard,notification,notificationaggregator,uploadwidget"
  extraPlugins:
  "colorbutton,font,justify,iframe,forms,div,smiley,pagebreak,templates,bidi,clipboard,notification,notificationaggregator,uploadwidget",
      embed_provider: "//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}",
      /* Remove warnings */
      // removePlugins: "notification,notificationaggregator",

      /*  Image upload */
          filebrowserUploadUrl: `${process.env.REACT_APP_API_URL}api/Ckupload`,
          // filebrowserUploadUrl: `${BASE_URL}api/Ckupload`,
               filebrowserUploadMethod: "post",
              //  filebrowserUploadMethod: "form",
    });

    /* change handler */
    // editor.on("change", () => {
    //   onChange?.({
    //     target: {
    //       name,
    //       value: editor.getData(),
    //     },
    //   });
    // });

    editor.on("change", () => {
  if (editor.status !== "ready") return;

  onChange?.({
    target: {
      name,
      value: editor.getData(),
    },
  });
});

    /* initial value */
    // editor.setData(value || "");

    editor.on("instanceReady", () => {
      editor.setData(latestValueRef.current || "");
    });

    editorInstanceRef.current = editor;

    return () => {
      editorInstanceRef.current?.destroy();
      editorInstanceRef.current = null;
    };
  }, []);

  /* ================= SYNC VALUE (EDIT MODE) ================= */
  // useEffect(() => {
  //   if (!editorInstanceRef.current) return;
  //   const current = editorInstanceRef.current.getData();
  //   if (current !== value) {
  //     editorInstanceRef.current.setData(value || "");
  //   }
  // }, [value]);

  useEffect(() => {
  const editor = editorInstanceRef.current;
  if (!editor) return;

  const currentData = editor.getData().trim();
  const newValue = (value || "").trim();

  if (currentData !== newValue) {
    editor.setData(newValue);
  }
}, [value]);

  return (
    <div className="mb-3">
      {label && (
        <Label className="form-label" htmlFor={name}>
          {label}
        </Label>
      )}

      {/* CKEditor mounts here */}
      <textarea ref={editorRef} name={name} />
    </div>
  );
};

export default FormEditor;
